import {createActionCreator, createVoidActionCreator} from '../common/actions';
import {PendingUserAction} from './reducer';

export const UserActionInitiated = createActionCreator<PendingUserAction>('USER_ACTION_INITIATED');
export const UserActionConfirmHandled = createVoidActionCreator('USER_ACTION_CONFIRM_HANDLED');
export const UserActionAlertHandled = createVoidActionCreator('USER_ACTION_ALERT_HANDLED');
